/** @format */

import * as R from 'ramda';

import {GroupedReport, ReportItemsType, ReportItemType} from './types';
import {
  ACCOUNT_FIELD,
  AD_FIELD,
  AD_GROUP_FIELD,
  CAMPAIGN_FIELD,
  KEYWORD_FIELD,
  OBJECT_HOST_FIELD,
  OBJECT_LINK_FIELD,
} from './constants';

const groupField = (sensorName: string): string => {
  const mapping: Record<string, string> = {
    'as-404': OBJECT_LINK_FIELD,
    'as-account-limit': ACCOUNT_FIELD,
    'as-account-limit-exceeded': ACCOUNT_FIELD,
    'as-ad-title-nokey': AD_GROUP_FIELD,
    'as-conversion-dropped': ACCOUNT_FIELD,
    'as-counters': ACCOUNT_FIELD,
    'as-different-domains': ACCOUNT_FIELD,
    'as-high-imp-ratio': ACCOUNT_FIELD,
    'as-low-balance': ACCOUNT_FIELD,
    'as-low-imp': AD_GROUP_FIELD,
    'as-low-spend-cap': ACCOUNT_FIELD,
    'as-pixel': OBJECT_HOST_FIELD,
    'as-spent': ACCOUNT_FIELD,
    'as-url-struct': OBJECT_LINK_FIELD,
    'as-use-utm-adwords': OBJECT_LINK_FIELD,
    'as-utm': OBJECT_LINK_FIELD,
    'as-utm-in-link': OBJECT_LINK_FIELD,
    // 'as-utm-param-double': OBJECT_LINK_FIELD,
    'as-utm-presence': OBJECT_LINK_FIELD,
    'as-utm-settings': OBJECT_LINK_FIELD,
  };

  return mapping[sensorName] || CAMPAIGN_FIELD;
};

const groupFieldPath = (sensorName: string): string[] | null => {
  const mapping: Record<string, string[] | null> = {
    [ACCOUNT_FIELD]: null,
    [CAMPAIGN_FIELD]: ['campaignId'],
    [AD_FIELD]: ['adId'],
    [KEYWORD_FIELD]: ['keywordId'],
    [OBJECT_LINK_FIELD]: ['objects', 'link', 'value'],
  };

  return mapping[groupField(sensorName)];
};

const groupReportItems = (sensorName: string, reportItems: ReportItemsType): GroupedReport => {
  const commonPaths = [['platform'], ['accountId']];
  const paths = [...commonPaths, groupFieldPath(sensorName)];

  return R.pipe(
    R.groupBy((row: ReportItemType) => String(R.paths(R.reject(R.isNil, paths), row))),
    R.values,
  )(reportItems ?? []) as GroupedReport;
};

const reportItemGroups = <K extends keyof ReportItemType>(
  locationField: K,
  reportItems: ReportItemsType,
): GroupedReport => {
  const NULL_KEY = '__NULL__';

  const keyFn = (row: ReportItemType) => {
    const v = row[locationField];
    return v == null ? NULL_KEY : String(v);
  };

  return R.pipe(
    R.groupBy<ReportItemType>(keyFn),
    R.dissoc(NULL_KEY),
    R.values,
  )(reportItems ?? []) as GroupedReport;
};

export {groupReportItems, groupField, reportItemGroups};
